import script from "./HomeRecommend.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeRecommend.vue?vue&type=script&lang=ts&setup=true"

import "./HomeRecommend.vue?vue&type=style&index=0&id=674f4be6&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-674f4be6"]])

export default __exports__